import script from "./CustomerLabelAddModel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerLabelAddModel.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerLabelAddModel.vue?vue&type=style&index=0&id=8fb74c86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fb74c86"]])

export default __exports__